import { render } from "./Me.vue?vue&type=template&id=385eec65&scoped=true&ts=true"
import script from "./Me.vue?vue&type=script&setup=true&lang=ts"
export * from "./Me.vue?vue&type=script&setup=true&lang=ts"

import "./Me.vue?vue&type=style&index=0&id=385eec65&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385eec65"],['__file',"src/views/me/Me.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "385eec65"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('385eec65', __exports__)) {
    console.log('reload')
    api.reload('385eec65', __exports__)
  }
  
  module.hot.accept("./Me.vue?vue&type=template&id=385eec65&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('385eec65', render)
  })

}


export default __exports__